import React from 'react';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';

const useValidateQuarterlyBusiness = (
  isLoading,
  isStartAssessment,
  transactionStatus,
  applicationStatus,
  onYesCallBack,
  onNoCallback = () => {}
) => {
  const isStatusAllowed =
    ['FOR CHECKING'].indexOf(transactionStatus) > -1;

  const isApplicationStatusAllowed =
    ['FOR LICENSE ASSESSMENT'].indexOf(applicationStatus) > -1;

  const isAllowed = true && isStatusAllowed && isApplicationStatusAllowed;

  const showComponent = isAllowed && isStartAssessment;

  const onHandleValidateQuarterlyBusiness = e => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure you want to validate this business?`,
      onYesCallBack,
      onNoCallback,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const component = showComponent ? (
    <div className="mx-2">
      <button
        disabled={isLoading}
        onClick={onHandleValidateQuarterlyBusiness}
        type="button"
        className='btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold'
      >
        {isLoading && (
          <>
            <i className="fas fa-spinner fa-spin" />
            &nbsp;
          </>
        )}
        Validate Business
        <span className="ml-1" />
      </button>
    </div>
  ) : null;

  return {
    isAllowed,
    onHandleValidateQuarterlyBusiness,
    component,
  };
};

export default useValidateQuarterlyBusiness;